// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Proxima Nova:300,300i,400,400i,500,500i,700,700i);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Titillium+Web:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://use.typekit.net/ija5zmr.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.titilliumweb_font {
  font-family: "Titillium Web", sans-serif !important;
}

.text-gray4 {
  color: #707070 !important;
}

.text-gray3 {
  color: #E5E5E5 !important;
}

.border-theme {
  border-color: #ced4da !important;
}

.text-theme {
  color: #36A1F5 !important;
}

.text-blue {
  color: #231c86 !important;
}

.theme-info {
  color: #00C2FF !important;
}

.bg-theme {
  background: #36A1F5 !important;
}

.bg-darkblue {
  background: #212B65 !important;
}

.theme-red {
  color: #ff0000 !important;
}

.theme-purple {
  color: #A300FF !important;
}

.theme-darkblue {
  color: #212B64 !important;
}

.border-darkblue {
  border-color: #212B65 !important;
}

/*----------------------------------------------
    Buttons
-----------------------------------------------*/
.btn-white {
  font-weight: 400;
  color: #000000;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #ffffff;
  border: 1px solid #ffffff;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-white:hover, .btn-white:active, .btn-white:focus, .btn-white:not(:disabled):not(.disabled):active:focus, .btn-white:not(:disabled):not(.disabled).active:focus, .btn-white:not(:disabled):not(.disabled):active {
  color: #000000;
  background: #f1f3f5;
  border: 1px solid #f1f3f5;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-white-outline {
  font-weight: 400;
  color: #707070;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: transparent;
  border: 1px solid #ced4da;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-white-outline:hover, .btn-white-outline:active, .btn-white-outline:focus, .btn-white-outline:not(:disabled):not(.disabled):active:focus, .btn-white-outline:not(:disabled):not(.disabled).active:focus, .btn-white-outline:not(:disabled):not(.disabled):active {
  color: #707070;
  background: #f1f3f5;
  border: 1px solid #ced4da;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-black {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #000000;
  border: 1px solid #000000;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-black:hover, .btn-black:active, .btn-black:focus, .btn-black:not(:disabled):not(.disabled):active:focus, .btn-black:not(:disabled):not(.disabled).active:focus, .btn-black:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background: #212529;
  border: 1px solid #212529;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-green {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #00C596;
  border: 1px solid #00C596;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-green:hover, .btn-green:active, .btn-green:focus, .btn-green:not(:disabled):not(.disabled):active:focus, .btn-green:not(:disabled):not(.disabled).active:focus, .btn-green:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #00a780;
  border: 1px solid #00a780;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightgreen {
  font-weight: 400;
  color: #00C596;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: hsla(166, 100%, 39%, 0.11);
  border: 1px solid #00C596;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightgreen:hover, .btn-lightgreen:active, .btn-lightgreen:focus, .btn-lightgreen:not(:disabled):not(.disabled):active:focus, .btn-lightgreen:not(:disabled):not(.disabled).active:focus, .btn-lightgreen:not(:disabled):not(.disabled):active {
  color: #00C596;
  background-color: hsla(166, 100%, 39%, 0.4);
  border: 1px solid #009b77;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-darkblue {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background: #202B63;
  border: 1px solid #3A4789;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-darkblue:hover, .btn-darkblue:active, .btn-darkblue:focus, .btn-darkblue:not(:disabled):not(.disabled):active:focus, .btn-darkblue:not(:disabled):not(.disabled).active:focus, .btn-darkblue:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background: #1c2658;
  border: 1px solid #303b74;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-darkblue-outline {
  font-weight: 400;
  color: #202B63;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background: #ffffff;
  border: 1px solid #3A4789;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-darkblue-outline:hover, .btn-darkblue-outline:active, .btn-darkblue-outline:focus, .btn-darkblue-outline:not(:disabled):not(.disabled):active:focus, .btn-darkblue-outline:not(:disabled):not(.disabled).active:focus, .btn-darkblue-outline:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background: #202B63;
  border: 1px solid #3A4789;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-blue {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #077EE6;
  border: 1px solid #077EE6;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-blue:hover, .btn-blue:active, .btn-blue:focus, .btn-blue:not(:disabled):not(.disabled):active:focus, .btn-blue:not(:disabled):not(.disabled).active:focus, .btn-blue:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #0172d4;
  border: 1px solid #0172d4;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-blue-outline {
  font-weight: 400;
  color: #077EE6;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #ffffff;
  border: 1px solid #077EE6;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-blue-outline:hover, .btn-blue-outline:active, .btn-blue-outline:focus, .btn-blue-outline:not(:disabled):not(.disabled):active:focus, .btn-blue-outline:not(:disabled):not(.disabled).active:focus, .btn-blue-outline:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #077EE6;
  border: 1px solid #077EE6;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightblue {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #36A1F5;
  border: 1px solid #36A1F5;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightblue:hover, .btn-lightblue:active, .btn-lightblue:focus, .btn-lightblue:not(:disabled):not(.disabled):active:focus, .btn-lightblue:not(:disabled):not(.disabled).active:focus, .btn-lightblue:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #2aa0fa;
  border: 1px solid #2aa0fa;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightblue-outline {
  font-weight: 400;
  color: #36A1F5;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #F2F9FF;
  border: 1px solid #36A1F5;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightblue-outline:hover, .btn-lightblue-outline:active, .btn-lightblue-outline:focus, .btn-lightblue-outline:not(:disabled):not(.disabled):active:focus, .btn-lightblue-outline:not(:disabled):not(.disabled).active:focus, .btn-lightblue-outline:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #36A1F5;
  border: 1px solid #36A1F5;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightred {
  font-weight: 400;
  color: #CB3F3F;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #FFEFEF;
  border: 1px solid #FF004E;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightred:hover, .btn-lightred:active, .btn-lightred:focus, .btn-lightred:not(:disabled):not(.disabled):active:focus, .btn-lightred:not(:disabled):not(.disabled).active:focus, .btn-lightred:not(:disabled):not(.disabled):active {
  color: #CB3F3F;
  background-color: #fda3a3;
  border: 1px solid #FF004E;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightOrange {
  font-weight: 400;
  color: #feb019;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #f8efde;
  border: 1px solid #feb019;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightOrange:hover, .btn-lightOrange:active, .btn-lightOrange:focus, .btn-lightOrange:not(:disabled):not(.disabled):active:focus, .btn-lightOrange:not(:disabled):not(.disabled).active:focus, .btn-lightOrange:not(:disabled):not(.disabled):active {
  color: #feb019;
  background-color: #fce9c5;
  border: 1px solid #feb019;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.strength-nav {
  position: relative;
  background: #ffeae5;
}
.strength-nav .header-top {
  position: relative;
  box-shadow: none;
  z-index: 2;
}
.strength-nav .header-top .navbar-nav {
  align-items: center;
}
.strength-nav .header-top .navbar-nav .nav-link {
  color: #333333;
}
.strength-nav .header-top .navbar-nav .profile-img {
  background: rgba(255, 255, 255, 0.1215686275);
  border: 1px solid #f9e1e1;
  border-radius: 21px;
}
.strength-nav .header-top .navbar-nav .profile-img img {
  width: 35px;
  height: 35px;
}
.strength-nav .header-top .navbar-nav .profile-img .text .profile-name {
  font-size: 14px;
  line-height: 6px;
}
.strength-nav .header-top .search .search-bar {
  color: #333333;
  background: rgba(255, 255, 255, 0.0901960784);
  box-shadow: none;
}
.strength-nav .header-top .student-notification i {
  font-size: 1.5rem;
}
.strength-nav .header-bottom {
  position: relative;
  z-index: 1;
}
.strength-nav .header-bottom .title {
  color: #ea6781;
}
.strength-nav .header-bottom .subtitle {
  color: #ea6781;
}
.strength-nav .header-bottom .list-inline li {
  margin-right: 35px;
  position: relative;
}
.strength-nav .header-bottom .list-inline li::before {
  right: -25px;
  bottom: 3px;
  position: absolute;
  color: #ffffff;
  content: "\\f30b";
  font-family: "Font Awesome 5 Pro";
  font-weight: 900;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
}
.strength-nav .header-bottom .list-inline li:last-child {
  margin-right: 0;
}
.strength-nav .header-bottom .list-inline li:last-child::before {
  display: none;
}
.strength-nav .header-bottom .card {
  border-radius: 10px;
  background-color: hsla(0, 0%, 100%, 0.46);
  border: 1px solid rgba(248, 174, 156, 0.5019607843);
}
.strength-nav .header-bottom .card img {
  margin-top: -3rem;
  margin-bottom: 10px;
}
.strength-nav .header-bottom .datePicker .calendar {
  color: #333333;
  position: absolute;
  left: 15px;
  top: 0;
  font-size: 18px;
  background: rgba(255, 255, 255, 0.4588235294);
  padding: 10px;
  border-radius: 4px;
}
.strength-nav .header-bottom .datePicker .form-control {
  padding-left: 40px;
  border: 1px solid rgba(0, 0, 0, 0.125);
  background-color: hsla(0, 0%, 100%, 0.46);
  color: #333333;
}
.strength-nav .header-bottom .datePicker .form-control::placeholder {
  color: #333333;
}
.strength-nav .header-bottom .datePicker .rdtPicker {
  right: 0;
}

.strength-analysis.student .subject-accureny {
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1607843137);
  border-radius: 0.4rem;
  border: 1px solid #fff !important;
}
.strength-analysis.student .subject-accureny .col:not(:last-child) {
  margin-right: 0.2rem;
}
.strength-analysis.student .subject-accureny .title-block {
  position: relative;
}
.strength-analysis.student .subject-accureny .title-block .title {
  font: normal normal normal 15px/20px Proxima Nova;
  letter-spacing: 0px;
  color: #213046;
  opacity: 0.5;
  margin: 35px -104px;
  transform: rotate(-90deg);
  position: absolute;
  width: 215px;
  left: 0;
}
.strength-analysis.student .subject-accureny .card {
  border-top-left-radius: 0.4rem;
  border-top-right-radius: 0;
  border-bottom-left-radius: 0.4rem;
  border-bottom-right-radius: 0;
}
.strength-analysis.student .subject-accureny .card .list-unstyled li:first-child small {
  font: normal normal normal 10px/12px Proxima Nova;
  letter-spacing: 0px;
  color: #FFFFFF;
}
.strength-analysis.student .subject-accureny .card .list-unstyled li:first-child h3 {
  font: normal normal bold 30px/26px Proxima Nova;
  letter-spacing: 0px;
  color: #FFFFFF;
}
.strength-analysis.student .subject-accureny .card .list-unstyled li:first-child p {
  font: normal normal bold 11px/13px Proxima Nova;
  letter-spacing: 0px;
  color: #DCF03E;
}
.strength-analysis.student .subject-accureny .card .list-unstyled li:first-child p small {
  font: normal normal normal 15px/13px Proxima Nova;
  letter-spacing: 0px;
  color: #DCF03E;
}
.strength-analysis.student .subject-accureny .card .content .subject-title {
  font: normal normal bold 15px/30px Segoe UI;
  letter-spacing: 0px;
  color: #FFFFFF;
  text-transform: capitalize;
}
.strength-analysis.student .subject-accureny .card .content .suject-icon svg {
  width: 30px;
  height: 30px;
}
.strength-analysis.student .subject-accureny .card.physics {
  background: #EE5D70;
}
.strength-analysis.student .subject-accureny .card.chemistry {
  background: #0960CE;
}
.strength-analysis.student .subject-accureny .card.botany {
  background: #3AC555;
}
.strength-analysis.student .subject-accureny .card.zoology {
  background: #C37800;
}
.strength-analysis.student .subject-accureny .card.mathematics {
  background: #01040A;
}
.strength-analysis.student .filter button {
  padding: 0.45rem 1rem;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1019607843);
}
.strength-analysis.student .single-row {
  background: #d8d8d8;
  border-radius: 10px;
}
@media (min-width: 1200px) {
  .strength-analysis.student .single-row .row > .col-xl-4 {
    padding-right: 4px;
  }
  .strength-analysis.student .single-row .row > .col-xl-4:last-child {
    padding-right: 15px;
  }
}
.strength-analysis.student .single-row .subject-card {
  overflow: hidden;
  border-radius: 10px;
}
.strength-analysis.student .single-row .subject-card .card-header .subject-status {
  background: #d8e1e9;
  border-radius: 10px;
  padding: 0.45rem 0.75rem;
}
.strength-analysis.student .single-row .subject-card .card-body .table {
  overflow: hidden;
  border-radius: 10px;
  margin-top: 4px;
  margin-bottom: 0;
}
.strength-analysis.student .single-row .subject-card .card-body .table .grayTxt {
  color: #333333;
  opacity: 0.8;
}
.strength-analysis.student .single-row .subject-card .card-body .table thead {
  overflow: hidden;
  background: #eeeeee;
  border-radius: 10px;
}
.strength-analysis.student .single-row .subject-card .card-body .table tbody tr:last-child {
  background: #eeeeee;
}
.strength-analysis.student .single-row .subject-card .card-body .table tbody h6 {
  font-size: 14px;
}
.strength-analysis.student .single-row .subject-card .card-body .table tbody p {
  font-size: 12px;
}
.strength-analysis.student .single-row .subject-card .card-body .table tbody h6,
.strength-analysis.student .single-row .subject-card .card-body .table tbody p {
  margin-bottom: 0;
}
.strength-analysis.student .single-row .Qappaired-card.mainstudent {
  border-radius: 10px;
}
.strength-analysis.student .single-row .Qappaired-card.mainstudent .question-status {
  background: #eeeeee;
  border-radius: 10px;
}
.strength-analysis.student .single-row .Qappaired-card.mainstudent .card-body .status-list {
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 10px;
}
.strength-analysis.student .single-row .Qappaired-card.mainstudent .card-body .status-list .list-inline-item {
  padding: 0.45rem;
  border-right: 1px solid #dee2e6;
}
.strength-analysis.student .single-row .Qappaired-card.mainstudent .card-body .status-list .list-inline-item .title {
  color: #6c757d;
  font-size: 13px;
  line-height: 14px !important;
  height: 36px !important;
}
.strength-analysis.student .single-row .Qappaired-card.mainstudent .card-body .status-list .list-inline-item:last-child {
  border-right: 0;
}
.strength-analysis.student .single-row .Qappaired-card.mainstudent .card-body .status-list .list-inline-item p {
  color: #333333;
}
.strength-analysis.student .single-row .Qappaired-card.mainstudent .card-body .react-bootstrap-table,
.strength-analysis.student .single-row .Qappaired-card.mainstudent .card-body .table {
  border: none;
  overflow: hidden;
  margin-bottom: 0;
  margin-top: 4px;
}
.strength-analysis.student .single-row .Qappaired-card.mainstudent .card-body .react-bootstrap-table thead tr th:nth-child(1),
.strength-analysis.student .single-row .Qappaired-card.mainstudent .card-body .table thead tr th:nth-child(1) {
  font-weight: 600 !important;
}
.strength-analysis.student .single-row .Qappaired-card.mainstudent .card-body .react-bootstrap-table thead tr th,
.strength-analysis.student .single-row .Qappaired-card.mainstudent .card-body .table thead tr th {
  background: #eeeeee;
  font-size: 12px !important;
  padding: 0.45rem 0.1rem;
  font-weight: 400 !important;
}
.strength-analysis.student .single-row .Qappaired-card.mainstudent .card-body .react-bootstrap-table tbody tr td,
.strength-analysis.student .single-row .Qappaired-card.mainstudent .card-body .table tbody tr td {
  font-size: 12px !important;
  line-height: 22px;
  padding: 0.15rem 0.15rem;
}
.strength-analysis.student .single-row .Qappaired-card.mainstudent .card-body .react-bootstrap-table tbody tr td:nth-child(2),
.strength-analysis.student .single-row .Qappaired-card.mainstudent .card-body .table tbody tr td:nth-child(2) {
  color: #077ee6;
}
.strength-analysis.student .single-row .Qappaired-card.mainstudent .card-body .react-bootstrap-table tbody tr td:nth-child(3),
.strength-analysis.student .single-row .Qappaired-card.mainstudent .card-body .table tbody tr td:nth-child(3) {
  color: #00c596;
}
.strength-analysis.student .single-row .Qappaired-card.mainstudent .card-body .react-bootstrap-table tbody tr td:nth-child(4),
.strength-analysis.student .single-row .Qappaired-card.mainstudent .card-body .table tbody tr td:nth-child(4) {
  color: #feaf55;
}
.strength-analysis.student .single-row .Qappaired-card.mainstudent .card-body .react-bootstrap-table tbody tr td:last-child,
.strength-analysis.student .single-row .Qappaired-card.mainstudent .card-body .table tbody tr td:last-child {
  color: #f05d70;
}
.strength-analysis.student .single-row .weeklist-card {
  border-radius: 10px;
}
.strength-analysis.student .single-row .weeklist-card .card-header {
  padding: 0.45rem 0.75rem;
}
.strength-analysis.student .single-row .weeklist-card .card-header .week-title {
  font-size: 14px;
  color: #333333;
}
.strength-analysis.student .single-row .weeklist-card .card-header .cutoff .form-label {
  margin-bottom: 0.2rem;
  font-size: 14px;
}
.strength-analysis.student .single-row .weeklist-card .card-header .cutoff select.form-control {
  height: 30px !important;
  padding: 0.175rem 0.25rem;
  font-size: 12px;
  width: 95px;
}
.strength-analysis.student .single-row .weeklist-card .card-header .cutoff select.form-control option {
  font-size: 12px;
}
.strength-analysis.student .single-row .weeklist-card .card-body .chapter-list li {
  background: #f6f6f6;
  padding: 0.45rem 0.75rem;
  border-radius: 6px;
  margin-bottom: 10px;
}
.strength-analysis.student .single-row .weeklist-card .card-body .chapter-list li:last-child {
  margin-bottom: 0;
}
.strength-analysis.student .single-row .weeklist-card .card-body .chapter-list li .title {
  font-weight: 600;
}
.strength-analysis.student .single-row .weeklist-card .card-body .chapter-list li .custom-control.custom-checkbox .custom-control-label {
  padding-right: 30px;
}
.strength-analysis.student .single-row .weeklist-card .card-body .chapter-list li .custom-control.custom-checkbox .custom-control-label::before {
  left: 2.5rem;
}
.strength-analysis.student .single-row .weeklist-card .card-body .chapter-list li .custom-control.custom-checkbox .custom-control-label::after {
  left: 2.5rem;
}
.strength-analysis.student .single-row .weeklist-card .card-body .btn {
  padding: 0.45rem 0.75rem;
}
.strength-analysis.student .syllabus-status .filter {
  margin: 0;
  padding: 0;
}
.strength-analysis.student .syllabus-status .filter li {
  display: inline-block;
  margin-right: 6px;
}
.strength-analysis.student .syllabus-status .filter li:last-child {
  margin-right: 0;
}
.strength-analysis.student .syllabus-status .filter li a {
  color: #000000;
  text-decoration: none;
  padding: 0.25rem 0.65rem;
  border-radius: 10px;
  transition: ease-in-out all 0.3s;
}
.strength-analysis.student .syllabus-status .filter li a:hover, .strength-analysis.student .syllabus-status .filter li a.active {
  color: #fff;
  background: #2fc84d;
  border-radius: 40px;
}`, "",{"version":3,"sources":["webpack://./src/_config.scss","webpack://./src/neetjee_guru/components/analysis/strength/_strength.scss"],"names":[],"mappings":"AAkCA;EACI,mDAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,gCAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,8BAAA;AC9BJ;;ADiCA;EACI,8BAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,gCAAA;AC9BJ;;ADkCA;;gDAAA;AAIA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AChCJ;ADkCI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;ACrCR;;ADyCA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6BAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACtCJ;ADwCI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;AC3CR;;AD+CA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AC5CJ;AD8CI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;ACjDR;;ADqDA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AClDJ;ADoDI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;ACvDR;;AD2DA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,4CAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACxDJ;AD0DI;EAMI,cAAA;EACA,2CAAA;EACA,yBAAA;EACA,iDAAA;AC7DR;;ADiEA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AC9DJ;ADgEI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;ACnER;;ADuEA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACpEJ;ADsEI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;ACzER;;AD6EA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AC1EJ;AD4EI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;AC/ER;;ADoFA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACjFJ;ADmFI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;ACtFR;;AD0FA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACvFJ;ADyFI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;AC5FR;;AD+FA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AC5FJ;AD8FI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;ACjGR;;ADqGA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AClGJ;ADqGI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;ACxGR;;AD4GA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACzGJ;AD2GI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;AC9GR;;AA9WA;EACE,kBAAA;EACA,mBAAA;AAiXF;AA/WE;EACE,kBAAA;EACA,gBAAA;EACA,UAAA;AAiXJ;AA/WI;EACE,mBAAA;AAiXN;AA/WM;EACE,cAAA;AAiXR;AA9WM;EACE,6CAAA;EACA,yBAAA;EACA,mBAAA;AAgXR;AA9WQ;EACE,WAAA;EACA,YAAA;AAgXV;AA5WU;EACE,eAAA;EACA,gBAAA;AA8WZ;AAxWI;EACE,cAAA;EACA,6CAAA;EACA,gBAAA;AA0WN;AAvWI;EACE,iBAAA;AAyWN;AArWE;EACE,kBAAA;EACA,UAAA;AAuWJ;AArWI;EACE,cAAA;AAuWN;AApWI;EACE,cAAA;AAsWN;AAnWI;EACE,kBAAA;EACA,kBAAA;AAqWN;AAnWM;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,iCAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;AAqWR;AAlWM;EACE,eAAA;AAoWR;AAlWQ;EACE,aAAA;AAoWV;AA/VI;EACE,mBAAA;EACA,yCAAA;EACA,mDAAA;AAiWN;AA/VM;EACE,iBAAA;EACA,mBAAA;AAiWR;AA5VM;EACE,cAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,eAAA;EACA,6CAAA;EACA,aAAA;EACA,kBAAA;AA8VR;AA3VM;EACE,kBAAA;EACA,sCAAA;EACA,yCAAA;EACA,cAAA;AA6VR;AA3VQ;EACE,cAAA;AA6VV;AAzVM;EACE,QAAA;AA2VR;;AApVE;EACE,oDAAA;EACA,qBAAA;EACA,iCAAA;AAuVJ;AArVI;EACI,oBAAA;AAuVR;AApVI;EACI,kBAAA;AAsVR;AApVQ;EACI,iDAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;AAsVZ;AAlVI;EACI,8BAAA;EACA,0BAAA;EACA,iCAAA;EACA,6BAAA;AAoVR;AAhVgB;EACI,iDAAA;EACA,mBAAA;EACA,cAAA;AAkVpB;AA/UgB;EACI,+CAAA;EACA,mBAAA;EACA,cAAA;AAiVpB;AA7UgB;EACI,+CAAA;EACA,mBAAA;EACA,cAAA;AA+UpB;AA7UoB;EACI,iDAAA;EACA,mBAAA;EACA,cAAA;AA+UxB;AAvUY;EACI,2CAAA;EACA,mBAAA;EACA,cAAA;EACA,0BAAA;AAyUhB;AApUgB;EACI,WAAA;EACA,YAAA;AAsUpB;AAjUQ;EACI,mBAAA;AAmUZ;AAhUQ;EACI,mBAAA;AAkUZ;AA/TQ;EACI,mBAAA;AAiUZ;AA9TQ;EACI,mBAAA;AAgUZ;AA7TQ;EACI,mBAAA;AA+TZ;AAxTI;EACE,qBAAA;EACA,oDAAA;AA0TN;AAtTE;EACE,mBAAA;EACA,mBAAA;AAwTJ;AAtTI;EACE;IACE,kBAAA;EAwTN;EAtTM;IACE,mBAAA;EAwTR;AACF;AApTI;EACE,gBAAA;EACA,mBAAA;AAsTN;AAnTQ;EACE,mBAAA;EACA,mBAAA;EACA,wBAAA;AAqTV;AAhTQ;EACE,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAkTV;AAhTU;EACE,cAAA;EACA,YAAA;AAkTZ;AA/SU;EACE,gBAAA;EACA,mBAAA;EACA,mBAAA;AAiTZ;AA9SU;EACE,mBAAA;AAgTZ;AA5SY;EACE,eAAA;AA8Sd;AA3SY;EACE,eAAA;AA6Sd;AA1SY;;EAEE,gBAAA;AA4Sd;AArSI;EACE,mBAAA;AAuSN;AArSM;EACE,mBAAA;EACA,mBAAA;AAuSR;AAnSQ;EACE,sBAAA;EACA,2BAAA;EACA,sCAAA;EACA,mBAAA;AAqSV;AAnSU;EACE,gBAAA;EACA,+BAAA;AAqSZ;AAnSY;EACE,cAAA;EACA,eAAA;EACA,4BAAA;EACA,uBAAA;AAqSd;AAlSY;EACE,eAAA;AAoSd;AAjSY;EACE,cAAA;AAmSd;AA9RQ;;EAEE,YAAA;EACA,gBAAA;EAEA,gBAAA;EACA,eAAA;AA+RV;AA7RU;;EACE,2BAAA;AAgSZ;AA7RU;;EAGE,mBAAA;EACA,0BAAA;EACA,uBAAA;EACA,2BAAA;AA8RZ;AA3RU;;EAGE,0BAAA;EACA,iBAAA;EACA,wBAAA;AA4RZ;AA1RY;;EACE,cAAA;AA6Rd;AA1RY;;EACE,cAAA;AA6Rd;AA1RY;;EACE,cAAA;AA6Rd;AA1RY;;EACE,cAAA;AA6Rd;AAtRI;EACE,mBAAA;AAwRN;AAvRM;EACE,wBAAA;AAyRR;AAvRQ;EACE,eAAA;EACA,cAAA;AAyRV;AArRU;EACE,qBAAA;EACA,eAAA;AAuRZ;AApRU;EACE,uBAAA;EACA,yBAAA;EACA,eAAA;EACA,WAAA;AAsRZ;AApRY;EACE,eAAA;AAsRd;AA9QU;EACE,mBAAA;EACA,wBAAA;EACA,kBAAA;EACA,mBAAA;AAgRZ;AA9QY;EACE,gBAAA;AAgRd;AA7QY;EACE,gBAAA;AA+Qd;AA3Qc;EACE,mBAAA;AA6QhB;AA3QgB;EACE,YAAA;AA6QlB;AA1QgB;EACE,YAAA;AA4QlB;AArQQ;EACE,wBAAA;AAuQV;AAhQI;EACE,SAAA;EACA,UAAA;AAkQN;AAhQM;EACE,qBAAA;EACA,iBAAA;AAkQR;AAhQQ;EACE,eAAA;AAkQV;AA/PQ;EACE,cAAA;EACA,qBAAA;EACA,wBAAA;EACA,mBAAA;EACA,gCAAA;AAiQV;AA/PU;EAEE,WAAA;EACA,mBAAA;EACA,mBAAA;AAgQZ","sourcesContent":["// @import url('https://fonts.googleapis.com/css?family=Ubuntu:300,300i,400,400i,500,500i,700,700i&display=swap');\n@import url('https://fonts.googleapis.com/css?family=Proxima%20Nova:300,300i,400,400i,500,500i,700,700i');\n@import url('https://fonts.googleapis.com/css2?family=Titillium+Web:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700&display=swap');\n@import url(\"https://use.typekit.net/ija5zmr.css\");\n\n$theme1: #36A1F5;\n$theme2: #1B2430;\n$white: #ffffff;\n$gray: #ced4da;\n$gray-2: #F2F2F2;\n$gray-3: #E5E5E5;\n$gray-4: #707070;\n$gray-5: #969DAA;\n$green: #01b306;\n$blue: #231c86;\n// #e7e9ea\n$one: #52B8FA;\n$two: #FAEF52;\n$three: #FABC52;\n$four: #AC52FA;\n$five: #FA52C2;\n$six: #FA5252;\n\n// $font-family: 'Ubuntu', sans-serif !important;\n$font-family: 'proxima-nova',\nsans-serif !important;\n\n@mixin fonts ($fontWeight, $fontSize, $lineHeight) {\n    font-family: $font-family;\n    font-size: $fontSize !important;\n    font-weight: $fontWeight !important;\n    line-height: $lineHeight;\n}\n\n.titilliumweb_font {\n    font-family: 'Titillium Web', sans-serif !important;\n}\n\n.text-gray4 {\n    color: $gray-4 !important;\n}\n\n.text-gray3 {\n    color: $gray-3 !important;\n}\n\n.border-theme {\n    border-color: $gray !important;\n}\n\n.text-theme {\n    color: $theme1 !important;\n}\n\n.text-blue {\n    color: $blue !important;\n}\n\n.theme-info {\n    color: #00C2FF !important;\n}\n\n.bg-theme {\n    background: $theme1 !important;\n}\n\n.bg-darkblue {\n    background: #212B65 !important;\n}\n\n.theme-red {\n    color: #ff0000 !important;\n}\n\n.theme-purple {\n    color: #A300FF !important;\n}\n\n.theme-darkblue {\n    color: #212B64 !important;\n}\n\n.border-darkblue {\n    border-color: #212B65 !important;\n}\n\n\n/*----------------------------------------------\n    Buttons\n-----------------------------------------------*/\n\n.btn-white {\n    font-weight: 400;\n    color: #000000;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #ffffff;\n    border: 1px solid #ffffff;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #000000;\n        background: #f1f3f5;\n        border: 1px solid #f1f3f5;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-white-outline {\n    font-weight: 400;\n    color: #707070;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: transparent;\n    border: 1px solid #ced4da;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #707070;\n        background: #f1f3f5;\n        border: 1px solid #ced4da;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-black {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #000000;\n    border: 1px solid #000000;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background: #212529;\n        border: 1px solid #212529;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-green {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #00C596;\n    border: 1px solid #00C596;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #00a780;\n        border: 1px solid #00a780;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-lightgreen {\n    font-weight: 400;\n    color: #00C596;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: hsla(166, 100%, 39%, 0.11);\n    border: 1px solid #00C596;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #00C596;\n        background-color: hsla(166, 100%, 39%, 0.4);\n        border: 1px solid #009b77;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-darkblue {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background: #202B63;\n    border: 1px solid #3A4789;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background: #1c2658;\n        border: 1px solid #303b74;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-darkblue-outline {\n    font-weight: 400;\n    color: #202B63;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background: #ffffff;\n    border: 1px solid #3A4789;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background: #202B63;\n        border: 1px solid #3A4789;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-blue {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #077EE6;\n    border: 1px solid #077EE6;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #0172d4;\n        border: 1px solid #0172d4;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n\n.btn-blue-outline {\n    font-weight: 400;\n    color: #077EE6;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #ffffff;\n    border: 1px solid #077EE6;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #077EE6;\n        border: 1px solid #077EE6;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-lightblue {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #36A1F5;\n    border: 1px solid #36A1F5;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #2aa0fa;\n        border: 1px solid #2aa0fa;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n.btn-lightblue-outline {\n    font-weight: 400;\n    color: #36A1F5;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #F2F9FF;\n    border: 1px solid #36A1F5;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #36A1F5;\n        border: 1px solid #36A1F5;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-lightred {\n    font-weight: 400;\n    color: #CB3F3F;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #FFEFEF;\n    border: 1px solid #FF004E;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #CB3F3F;\n        background-color: #fda3a3;\n        border: 1px solid #FF004E;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-lightOrange {\n    font-weight: 400;\n    color: #feb019;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #f8efde;\n    border: 1px solid #feb019;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #feb019;\n        background-color: #fce9c5;\n        border: 1px solid #feb019;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}","@import \"../../../../_config.scss\";\n\n.strength-nav {\n  position: relative;\n  background: #ffeae5;\n\n  .header-top {\n    position: relative;\n    box-shadow: none;\n    z-index: 2;\n\n    .navbar-nav {\n      align-items: center;\n\n      .nav-link {\n        color: #333333;\n      }\n\n      .profile-img {\n        background: #ffffff1f;\n        border: 1px solid #f9e1e1;\n        border-radius: 21px;\n\n        img {\n          width: 35px;\n          height: 35px;\n        }\n\n        .text {\n          .profile-name {\n            font-size: 14px;\n            line-height: 6px;\n          }\n        }\n      }\n    }\n\n    .search .search-bar {\n      color: #333333;\n      background: #ffffff17;\n      box-shadow: none;\n    }\n\n    .student-notification i {\n      font-size: 1.5rem;\n    }\n  }\n\n  .header-bottom {\n    position: relative;\n    z-index: 1;\n\n    .title {\n      color: #ea6781;\n    }\n\n    .subtitle {\n      color: #ea6781;\n    }\n\n    .list-inline li {\n      margin-right: 35px;\n      position: relative;\n\n      &::before {\n        right: -25px;\n        bottom: 3px;\n        position: absolute;\n        color: #ffffff;\n        content: \"\\f30b\";\n        font-family: \"Font Awesome 5 Pro\";\n        font-weight: 900;\n        display: inline-block;\n        font-style: normal;\n        font-variant: normal;\n        text-rendering: auto;\n        line-height: 1;\n      }\n\n      &:last-child {\n        margin-right: 0;\n\n        &::before {\n          display: none;\n        }\n      }\n    }\n\n    .card {\n      border-radius: 10px;\n      background-color: hsla(0, 0%, 100%, 0.46);\n      border: 1px solid #f8ae9c80;\n\n      img {\n        margin-top: -3rem;\n        margin-bottom: 10px;\n      }\n    }\n\n    .datePicker {\n      .calendar {\n        color: #333333;\n        position: absolute;\n        left: 15px;\n        top: 0;\n        font-size: 18px;\n        background: #ffffff75;\n        padding: 10px;\n        border-radius: 4px;\n      }\n\n      .form-control {\n        padding-left: 40px;\n        border: 1px solid rgba(0, 0, 0, 0.125);\n        background-color: hsla(0, 0%, 100%, 0.46);\n        color: #333333;\n\n        &::placeholder {\n          color: #333333;\n        }\n      }\n\n      .rdtPicker {\n        right: 0;\n      }\n    }\n  }\n}\n\n.strength-analysis.student {\n  .subject-accureny {\n    box-shadow: 0px 3px 20px #00000029;\n    border-radius: 0.4rem;\n    border: 1px solid #fff !important;\n\n    .col:not(:last-child) {\n        margin-right: .2rem;\n    }\n\n    .title-block {\n        position: relative;\n\n        .title {\n            font: normal normal normal 15px/20px Proxima Nova;\n            letter-spacing: 0px;\n            color: #213046;\n            opacity: 0.5;\n            margin: 35px -104px;\n            transform: rotate(-90deg);\n            position: absolute;\n            width: 215px;\n            left: 0;\n        }\n    }\n\n    .card {\n        border-top-left-radius: 0.4rem;\n        border-top-right-radius: 0;\n        border-bottom-left-radius: 0.4rem;\n        border-bottom-right-radius: 0;\n\n        .list-unstyled li {\n            &:first-child {\n                small {\n                    font: normal normal normal 10px/12px Proxima Nova;\n                    letter-spacing: 0px;\n                    color: #FFFFFF;\n                }\n\n                h3 {\n                    font: normal normal bold 30px/26px Proxima Nova;\n                    letter-spacing: 0px;\n                    color: #FFFFFF;\n\n                }\n\n                p {\n                    font: normal normal bold 11px/13px Proxima Nova;\n                    letter-spacing: 0px;\n                    color: #DCF03E;\n\n                    small {\n                        font: normal normal normal 15px/13px Proxima Nova;\n                        letter-spacing: 0px;\n                        color: #DCF03E;\n                    }\n                }\n            }\n        }\n\n        .content {\n\n            .subject-title {\n                font: normal normal bold 15px/30px Segoe UI;\n                letter-spacing: 0px;\n                color: #FFFFFF;\n                text-transform: capitalize;\n            }\n\n            .suject-icon {\n\n                svg {\n                    width: 30px;\n                    height: 30px;\n                }\n            }\n        }\n\n        &.physics {\n            background: #EE5D70;\n        }\n\n        &.chemistry {\n            background: #0960CE;\n        }\n\n        &.botany {\n            background: #3AC555;\n        }\n\n        &.zoology {\n            background: #C37800;\n        }\n\n        &.mathematics {\n            background: #01040A;\n        }\n    }\n}\n\n\n  .filter {\n    button {\n      padding: 0.45rem 1rem;\n      box-shadow: 0px 0px 10px #0000001a;\n    }\n  }\n\n  .single-row {\n    background: #d8d8d8;\n    border-radius: 10px;\n\n    @media (min-width: 1200px) {\n      .row > .col-xl-4 {\n        padding-right: 4px;\n\n        &:last-child {\n          padding-right: 15px;\n        }\n      }\n    }\n\n    .subject-card {\n      overflow: hidden;\n      border-radius: 10px;\n\n      .card-header {\n        .subject-status {\n          background: #d8e1e9;\n          border-radius: 10px;\n          padding: 0.45rem 0.75rem;\n        }\n      }\n\n      .card-body {\n        .table {\n          overflow: hidden;\n          border-radius: 10px;\n          margin-top: 4px;\n          margin-bottom: 0;\n\n          .grayTxt {\n            color: #333333;\n            opacity: 0.8;\n          }\n\n          thead {\n            overflow: hidden;\n            background: #eeeeee;\n            border-radius: 10px;\n          }\n\n          tbody tr:last-child {\n            background: #eeeeee;\n          }\n\n          tbody {\n            h6 {\n              font-size: 14px;\n            }\n\n            p {\n              font-size: 12px;\n            }\n\n            h6,\n            p {\n              margin-bottom: 0;\n            }\n          }\n        }\n      }\n    }\n\n    .Qappaired-card.mainstudent {\n      border-radius: 10px;\n\n      .question-status {\n        background: #eeeeee;\n        border-radius: 10px;\n      }\n\n      .card-body {\n        .status-list {\n          background-color: #fff;\n          background-clip: border-box;\n          border: 1px solid rgba(0, 0, 0, 0.125);\n          border-radius: 10px;\n\n          .list-inline-item {\n            padding: 0.45rem;\n            border-right: 1px solid #dee2e6;\n\n            .title {\n              color: #6c757d;\n              font-size: 13px;\n              line-height: 14px !important;\n              height: 36px !important;\n            }\n\n            &:last-child {\n              border-right: 0;\n            }\n\n            p {\n              color: #333333;\n            }\n          }\n        }\n\n        .react-bootstrap-table,\n        .table {\n          border: none;\n          overflow: hidden;\n          // border-radius: 10px;\n          margin-bottom: 0;\n          margin-top: 4px;\n         \n          thead tr th:nth-child(1) {\n            font-weight: 600 !important;\n          }\n\n          thead tr th {\n            // font-size: 13px;\n            // padding: 0.4rem 0.35rem;\n            background: #eeeeee;\n            font-size: 12px !important;\n            padding: 0.45rem 0.1rem;\n            font-weight: 400 !important;\n          }\n\n          tbody tr td {\n            // font-size: 12px;\n            // padding: 0.38rem 0.35rem;\n            font-size: 12px !important;\n            line-height: 22px;\n            padding: 0.15rem 0.15rem;\n\n            &:nth-child(2) {\n              color: #077ee6;\n            }\n\n            &:nth-child(3) {\n              color: #00c596;\n            }\n\n            &:nth-child(4) {\n              color: #feaf55;\n            }\n\n            &:last-child {\n              color: #f05d70;\n            }\n          }\n        }\n      }\n    }\n\n    .weeklist-card {\n      border-radius: 10px;\n      .card-header {\n        padding: 0.45rem 0.75rem;\n\n        .week-title {\n          font-size: 14px;\n          color: #333333;\n        }\n\n        .cutoff {\n          .form-label {\n            margin-bottom: 0.2rem;\n            font-size: 14px;\n          }\n\n          select.form-control {\n            height: 30px !important;\n            padding: 0.175rem 0.25rem;\n            font-size: 12px;\n            width: 95px;\n\n            option {\n              font-size: 12px;\n            }\n          }\n        }\n      }\n\n      .card-body {\n        .chapter-list {\n          li {\n            background: #f6f6f6;\n            padding: 0.45rem 0.75rem;\n            border-radius: 6px;\n            margin-bottom: 10px;\n\n            &:last-child {\n              margin-bottom: 0;\n            }\n\n            .title {\n              font-weight: 600;\n            }\n\n            .custom-control.custom-checkbox {\n              .custom-control-label {\n                padding-right: 30px;\n\n                &::before {\n                  left: 2.5rem;\n                }\n\n                &::after {\n                  left: 2.5rem;\n                }\n              }\n            }\n          }\n        }\n\n        .btn {\n          padding: 0.45rem 0.75rem;\n        }\n      }\n    }\n  }\n\n  .syllabus-status {\n    .filter {\n      margin: 0;\n      padding: 0;\n\n      li {\n        display: inline-block;\n        margin-right: 6px;\n\n        &:last-child {\n          margin-right: 0;\n        }\n\n        a {\n          color: #000000;\n          text-decoration: none;\n          padding: 0.25rem 0.65rem;\n          border-radius: 10px;\n          transition: ease-in-out all 0.3s;\n\n          &:hover,\n          &.active {\n            color: #fff;\n            background: #2fc84d;\n            border-radius: 40px;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
